import { z } from 'zod';

import { TaskClosingCodeSchema } from './TaskClosingCodeSchema';

export const TaskCodeSchema = z.object({
  code: TaskClosingCodeSchema.extend({
    shortName: z.string().max(10).optional()
  })
});
